const DPPType = {
  GET_DPP_DATA_BYID: 'GET_DPP_DATA_BYID',
  GET_ALL_DPP_LIST: 'GET_ALL_DPP_LIST',
  UNMOUNT_DPP_LIST: 'UNMOUNT_DPP_LIST',
  UNMOUNT_DPP_LIBRARY: 'UNMOUNT_DPP_LIBRARY',
};

export default DPPType;
